export enum RESTRICTION_GROUP {
  MONETARY = 'Monetario',
  DELEGATION = 'Delegación de poderes',
  LOCALITY = 'Localidad',
  EXPIRATION_DATE = 'Fecha de vigencia',
}

export enum MONETARY_UNIT {
  CLP = 'CLP',
  UF = 'UF',
}

export enum DELEGATION_UNIT {
  ONE = 1,
  TWO = 2,
}

export enum GENERIC_UNIT {
  LOCALITY = 'locality',
  EXPIRATION_DATE = 'expirationDate',
}

export type MonetaryRestriction = {
  type: RESTRICTION_GROUP.MONETARY;
  values: Array<{
    value: MONETARY_UNIT;
    displayName: string;
    defaultValue: string;
  }>;
};

type DelegationRestriction = {
  type: RESTRICTION_GROUP.DELEGATION;
  values: Array<{
    value: DELEGATION_UNIT;
    displayName: string;
    defaultValue: string;
  }>;
};

type GenericRestriction = {
  type: RESTRICTION_GROUP.LOCALITY | RESTRICTION_GROUP.EXPIRATION_DATE;
  values: Array<{
    value: string;
    displayName: string;
    defaultValue: string;
  }>;
};

export type RestrictionUnit =
  MonetaryRestriction | DelegationRestriction | GenericRestriction;

export const RESTRICTION_UNITS: RestrictionUnit[] = [
  {
    type: RESTRICTION_GROUP.MONETARY,
    values: [
      {
        value: MONETARY_UNIT.CLP,
        displayName: 'Pesos Chilenos',
        defaultValue: null,
      },
      {
        value: MONETARY_UNIT.UF,
        displayName: 'Unidades de Fomento',
        defaultValue: null,
      },
    ],
  },
  {
    type: RESTRICTION_GROUP.DELEGATION,
    values: [
      {
        value: DELEGATION_UNIT.ONE,
        displayName: '1',
        defaultValue: 'clausula administrador',
      },
      {
        value: DELEGATION_UNIT.TWO,
        displayName: '2',
        defaultValue: 'clausula administrador y clausula gerente general',
      },
    ],
  },
  {
    type: RESTRICTION_GROUP.LOCALITY,
    values: [
      {
        value: GENERIC_UNIT.LOCALITY,
        displayName: 'Localidad',
        defaultValue: null,
      },
    ],
  },
  {
    type: RESTRICTION_GROUP.EXPIRATION_DATE,
    values: [
      {
        value: GENERIC_UNIT.EXPIRATION_DATE,
        displayName: 'Fecha de vigencia',
        defaultValue: null,
      },
    ],
  },
];
